/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Conf47TypeEnum } from './Conf47TypeEnum';
import {
    Conf47TypeEnumFromJSON,
    Conf47TypeEnumFromJSONTyped,
    Conf47TypeEnumToJSON,
    Conf47TypeEnumToJSONTyped,
} from './Conf47TypeEnum';
import type { DeviceTypeEnum } from './DeviceTypeEnum';
import {
    DeviceTypeEnumFromJSON,
    DeviceTypeEnumFromJSONTyped,
    DeviceTypeEnumToJSON,
    DeviceTypeEnumToJSONTyped,
} from './DeviceTypeEnum';

/**
 * 
 * @export
 * @interface DeviceCreate
 */
export interface DeviceCreate {
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    idDevice: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    idClient: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    syslogHost: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceCreate
     */
    syslogPort: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    syslogFacility: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    provisioning: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceCreate
     */
    keepaliveTimer: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    mqttHost: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceCreate
     */
    mqttPort: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    mqttUser: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    mqttPass: string;
    /**
     * 
     * @type {Conf47TypeEnum}
     * @memberof DeviceCreate
     */
    conf47Type?: Conf47TypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof DeviceCreate
     */
    dateTime: Date;
    /**
     * 
     * @type {DeviceTypeEnum}
     * @memberof DeviceCreate
     */
    deviceType?: DeviceTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceCreate
     */
    mqttVoiceDsts?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceCreate
     */
    jsonAdditionalConfig?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCreate
     */
    phone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCreate
     */
    needsRefresh?: boolean | null;
}



/**
 * Check if a given object implements the DeviceCreate interface.
 */
export function instanceOfDeviceCreate(value: object): value is DeviceCreate {
    if (!('idDevice' in value) || value['idDevice'] === undefined) return false;
    if (!('idClient' in value) || value['idClient'] === undefined) return false;
    if (!('syslogHost' in value) || value['syslogHost'] === undefined) return false;
    if (!('syslogPort' in value) || value['syslogPort'] === undefined) return false;
    if (!('syslogFacility' in value) || value['syslogFacility'] === undefined) return false;
    if (!('provisioning' in value) || value['provisioning'] === undefined) return false;
    if (!('keepaliveTimer' in value) || value['keepaliveTimer'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('mqttHost' in value) || value['mqttHost'] === undefined) return false;
    if (!('mqttPort' in value) || value['mqttPort'] === undefined) return false;
    if (!('mqttUser' in value) || value['mqttUser'] === undefined) return false;
    if (!('mqttPass' in value) || value['mqttPass'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    return true;
}

export function DeviceCreateFromJSON(json: any): DeviceCreate {
    return DeviceCreateFromJSONTyped(json, false);
}

export function DeviceCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'idDevice': json['idDevice'],
        'idClient': json['idClient'],
        'syslogHost': json['syslog_host'],
        'syslogPort': json['syslog_port'],
        'syslogFacility': json['syslog_facility'],
        'provisioning': json['provisioning'],
        'keepaliveTimer': json['keepalive_timer'],
        'password': json['password'],
        'mqttHost': json['mqtt_host'],
        'mqttPort': json['mqtt_port'],
        'mqttUser': json['mqtt_user'],
        'mqttPass': json['mqtt_pass'],
        'conf47Type': json['conf47Type'] == null ? undefined : Conf47TypeEnumFromJSON(json['conf47Type']),
        'dateTime': (new Date(json['date_time'])),
        'deviceType': json['deviceType'] == null ? undefined : DeviceTypeEnumFromJSON(json['deviceType']),
        'mqttVoiceDsts': json['mqtt_voice_dsts'] == null ? undefined : json['mqtt_voice_dsts'],
        'jsonAdditionalConfig': json['jsonAdditionalConfig'] == null ? undefined : json['jsonAdditionalConfig'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'needsRefresh': json['needsRefresh'] == null ? undefined : json['needsRefresh'],
    };
}

export function DeviceCreateToJSON(json: any): DeviceCreate {
    return DeviceCreateToJSONTyped(json, false);
}

export function DeviceCreateToJSONTyped(value?: DeviceCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idDevice': value['idDevice'],
        'idClient': value['idClient'],
        'syslog_host': value['syslogHost'],
        'syslog_port': value['syslogPort'],
        'syslog_facility': value['syslogFacility'],
        'provisioning': value['provisioning'],
        'keepalive_timer': value['keepaliveTimer'],
        'password': value['password'],
        'mqtt_host': value['mqttHost'],
        'mqtt_port': value['mqttPort'],
        'mqtt_user': value['mqttUser'],
        'mqtt_pass': value['mqttPass'],
        'conf47Type': Conf47TypeEnumToJSON(value['conf47Type']),
        'date_time': (typeof value['dateTime'] === 'string' ? value['dateTime'] : (value['dateTime'] as any)?.toISOString()),
        'deviceType': DeviceTypeEnumToJSON(value['deviceType']),
        'mqtt_voice_dsts': value['mqttVoiceDsts'],
        'jsonAdditionalConfig': value['jsonAdditionalConfig'],
        'phone': value['phone'],
        'needsRefresh': value['needsRefresh'],
    };
}

